import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SuccessMessage = ({ clientData, onAddMinutes, onReturnToDashboard, onCreateAnother }) => {
  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-8 text-center">
      <div className="mb-6">
        <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} className="text-success" />
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Client Created Successfully!
        </h2>
        <p className="text-muted-foreground">
          {clientData.fullName} has been added to your client database.
        </p>
      </div>

      {/* Client Summary */}
      <div className="bg-muted rounded-lg p-6 mb-8 text-left">
        <h3 className="font-semibold text-foreground mb-4 flex items-center">
          <Icon name="User" size={18} className="mr-2" />
          Client Details
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Full Name:</span>
            <span className="font-medium text-foreground">{clientData.fullName}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Mobile Number:</span>
            <span className="font-medium text-foreground font-mono">{clientData.mobileNumber}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Total Minutes:</span>
            <span className={`font-medium font-mono ${
              clientData.initialMinutes > 0 ? 'text-success' : 'text-muted-foreground'
            }`}>
              {clientData.initialMinutes} minutes
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-muted-foreground">Created:</span>
            <span className="font-medium text-foreground">
              {new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </span>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="space-y-4">
        {clientData.initialMinutes === 0 && (
          <Button
            variant="default"
            size="lg"
            onClick={onAddMinutes}
            iconName="Plus"
            iconPosition="left"
            iconSize={18}
            fullWidth
            className="bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200 hover:shadow-md"
          >
            Add Minutes Now
          </Button>
        )}

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            size="lg"
            onClick={onCreateAnother}
            iconName="UserPlus"
            iconPosition="left"
            iconSize={18}
            className="flex-1 transition-all duration-200"
          >
            Create Another Client
          </Button>

          <Button
            variant="secondary"
            size="lg"
            onClick={onReturnToDashboard}
            iconName="LayoutDashboard"
            iconPosition="left"
            iconSize={18}
            className="flex-1 transition-all duration-200"
          >
            Return to Dashboard
          </Button>
        </div>
      </div>

      {/* Additional Info */}
      <div className="mt-8 p-4 bg-accent/10 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Lightbulb" size={18} className="text-accent mt-0.5 flex-shrink-0" />
          <div className="text-sm text-muted-foreground text-left">
            <p className="font-medium text-foreground mb-1">What's Next?</p>
            <ul className="space-y-1">
              <li>• Use the search bar to quickly find this client</li>
              <li>• Add or subtract minutes from their profile page</li>
              <li>• View all clients from the dashboard</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;